import fetch from './fetch'
import { isApp } from '../tools/mgtv/env';
import { getStore, removeStore } from './mUtils';
import { TICKET } from '../constant/CookieKeys';
import { logout, login } from '../tools/mgtv/login';

/**
 * 1、在线人数
 */

export const getOnline = () => fetch('/sale/onlineNum', {
	
},'GET','ajax');

/**
 * 2、前100
 */

export const getTop100Left = () => fetch('/sale/top', {
	
},'GET','ajax');
/**
 * 3、获取订单列表
 */

export const getOrderList = (ticket) => fetch('/sale/user/myOrder', {
	ticket
},'GET','ajax');

/**
 * 4、获取代金券列表
 */

export const getCouponList = (ticket,productId) => fetch('/sale/user/aaa/myVouchers', {
    ticket,
    productId
},'GET','ajax');

/**
 * 5、预售手机号保存(废弃)
 */

export const sendPhone = (ticket,phone) => fetch('/sale/user/yushouPhone', {
	ticket,	
	phone
}, 'POST');



/**
 * 6、下单
 */

export const sendOrder = (ticket,productId,openid,channel,address,phone,receiverName,voucherid,returnUrl,mac) => fetch('/sale/user/aaa/buyProduct', {
	ticket,
    productId,
    openid,
    channel,
    address,
	phone,
	receiverName,
	voucherid,
    returnUrl,
    mac
}, 'POST','ajax');

/**
 * 7、保存收货地址
 */

export const sendOrderAddr = (ticket,orderId,phone,receiverName,address) => fetch('/sale/user/updateAddress', {
	ticket,
	orderId,
	phone,
	receiverName,
	address,
}, 'POST','ajax');

/**
 * 8、获取当前时间
 */

export const getCurrTime= () => fetch('/sale/now',{},'GET','ajax');
/**
 * 8、获取当前时间
 */

export const getActSection= () => fetch('/sale/activitySection',{},'GET','ajax');

/**
 * 9、获取openid
 */

export const getOpenid= (code) => fetch('/usercenter/v2/mangoLogin/baseInfo/'+code,{},'GET','ajax');
/**
 * 10、获取用户信息
 */

export const getUserInfo= (ticket,deviceId) => fetch('/usercenter/v2/uc/myInfo',{
	ticket,
	deviceId
}, 'GET','ajax');
/**
 * 11、获取ticket
 */
export const getTicket= ()=>{
	return new Promise((resolve,reject)=>{
		if (isApp()) {
			MgtvApi.getUserInfo(function (user_info) {
				if (user_info && user_info.length !== 0) {
					const ticket = (JSON.parse(user_info)).ticket;
					resolve(ticket);
				}else{
					resolve(null);//没有登录
				}
			})
		} else {
			const ticket = getStore(TICKET)
			if(ticket)
				resolve(ticket)
			else
				resolve(null)
		}
	})
}

export const getDeviceInfo= ()=>{
	return new Promise((resolve,reject)=>{
		const device_info_default = {
			appVersion: '5.9.9_vipact',
			mac: '0000-0000-0000',
			did: '0000-0000-0000',
			osType: window.gact.os,
		};
		if (isApp()) {
			MgtvApi.getDeviceInfo(function (_device_info) {
				console.log(_device_info, typeof _device_info)
				if (_device_info.length !== 0) {
					const device_info = JSON.parse(_device_info);
					//防止老版本中mac和did为空，导致下单失败
					if (!device_info.mac) {
						device_info.mac = '0000-0000-0000';
					}
					if (!device_info.did) {
						device_info.did = '0000-0000-0000';
					}
					resolve(device_info);
				} else {					
					resolve(device_info_default)
				}
			});			
		}
		else{
			resolve(device_info_default)
		}
	})
}




/**
 * 11、登录
 */
export const glogin= ()=>{
	return new Promise((resolve,reject)=>{
		setTimeout(() => {
			removeStore(TICKET)
			if (isApp()) {
				MgtvApi.login(data => {
					const userInfo = data && JSON.parse(data);
					if(userInfo){
						resolve(userInfo)
					}
					else{
						resolve(null)
					}
					// window.$bus.$emit(ACTION_GET_USER_INFO, userInfo.ticket);
				});
			} else {
				login()
			}
		}, 300);
	});
}




// WEBPACK FOOTER //
// ./src/api/getData.js